import React from 'react';
import {pageRoutes} from '../..';

export const cargoRouteConfig = [
  {
    routes: [
      {
        auth: ['user'],
        path: pageRoutes.SUBMIT_RECEIPT,
        component: React.lazy(() => import('./submitReceipt')),
      },
    ],
  },
  {
    routes: [
      {
        auth: ['user'],
        path: pageRoutes.CHECK_RECEIPT,
        component: React.lazy(() => import('./checkReceipt')),
      },
    ],
  },
  {
    routes: [
      {
        auth: ['user'],
        path: pageRoutes.REFUND_OR_VIOD,
        component: React.lazy(() => import('./refundOrVoid')),
      },
    ],
  },
  {
    routes: [
      {
        auth: ['user'],
        path: pageRoutes.CONFIRM_REFUND_OR_VIOD,
        component: React.lazy(() => import('./confirmRefundOrVoid')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.TEMPORARY_AWB_LIST,
        component: React.lazy(() => import('./awbList')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.ISSUED_AWB_LIST,
        component: React.lazy(() => import('./awbList')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.DRAFT_AWB_LIST,
        component: React.lazy(() => import('./awbList')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.RESERVED_AWB_LIST,
        component: React.lazy(() => import('./awbList')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.CCA_AWB_LIST,
        component: React.lazy(() => import('./ccaList')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.RETURN_MONEY_LIST,
        component: React.lazy(() => import('./returnMoney')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.TRANSACTIONS_LIST,
        component: React.lazy(() => import('./transaction')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.CHARGE_USER,
        component: React.lazy(() => import('./charge')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.USER_SETTINGS,
        component: React.lazy(() => import('./userSettings')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.USER_CHARGE_DETAIL,
        component: React.lazy(() => import('./userChargeDetail')),
      },
    ],
  },

  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.CHARGE_DETAIL,
        component: React.lazy(() => import('./chargeDetail')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.COMMISION,
        component: React.lazy(() => import('./commissionList')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.RATE_CLASS,
        component: React.lazy(() => import('./rateClass')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.C_R_C,
        component: React.lazy(() => import('./customizeRateClass')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.MANIFEST,
        component: React.lazy(() => import('./manifest')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.PRICING,
        component: React.lazy(() => import('./pricing')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.ONLINE_CHARGE_DETAIL,
        component: React.lazy(() => import('./onlineChargeDetail')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.PAYMENT_REDIRECT,
        component: React.lazy(() => import('./paymentRedirect')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.PAYMENT_REPORT,
        component: React.lazy(() => import('./paymentReport')),
      },
    ],
  },
  {
    auth: ['user'],
    exact: true,
    routes: [
      {
        path: pageRoutes.RTRD,
        component: React.lazy(() => import('./RTRD')),
      },
    ],
  },
];
